import { useRef, useContext, useEffect, useState } from 'react';
import { EmbedSiteShortContext } from 'App.js';

export default function PaymentInfoModals({novunaOptions, novunaTerms, paypalOptions, dopplePay, doppleZeroInterest})
{
    const closeModalButton = useRef(null);
    const site = useContext(EmbedSiteShortContext);
    var companyName = "";

    switch (site)
    {
        case "ccl":
            companyName = "CCL Computers Limited";
            break;
        default:
    }

    const iframeRef = useRef(null);
    const [iframeSrc, setIframeSrc] = useState(null);

    useEffect(() => {
        if (dopplePay)
        {
            const { apiDomain, systemID, totalCostText } = doppleZeroInterest ?? dopplePay;
            
            if (site === "chillblast") 
            {
                const src = `https://${apiDomain}/api/merchants/v1/information/product-finance-calculator/${systemID}?value=${totalCostText}`;
                setIframeSrc(src);
            }
            else
            {
                setIframeSrc(null);
            }
        }
    }, [site, dopplePay, doppleZeroInterest]);

	return (
        <>
		    {/* Novuna Finance modal*/}
            {
                (novunaOptions && novunaOptions.length > 0)
                &&
                    <div className="finance-modal modal fade" id="financeModal" tabIndex="-1" aria-labelledby="financeModalLabel" aria-hidden="true" data-bs-backdrop="static">
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header border-0">
                                    <h2 className="modal-title mb-0">Spread the cost with Novuna Finance</h2>
                                    <button ref={closeModalButton} type="button" className="btn-close close-button float-end" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">

                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th className="text-casing text-muted">Payment plan</th>
                                                <th className="text-casing text-muted">Deposit</th>
                                                <th className="text-casing text-muted">Monthly payment</th>
                                                <th className="text-casing text-muted">Instalment rate</th>
                                                <th className="text-casing text-muted">Cost of Purchase</th>
                                                <th className="text-casing text-muted">Total payment</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                novunaOptions.map((product, index) =>

                                                    <tr key={"product_" + index}>
                                                        <th>{product.description}</th>
                                                        <td><span dangerouslySetInnerHTML={{ __html: product.depositText }} ></span></td>
                                                        <td><span dangerouslySetInnerHTML={{ __html: product.monthlyPaymentText }} ></span>{product.moreInfoAsterisk}</td>
                                                        <td>{product.instalmentRateText}</td>
                                                        <td><span dangerouslySetInnerHTML={{ __html: product.costOfPurchaseText }} ></span></td>
                                                        <td><span dangerouslySetInnerHTML={{ __html: product.totalAmountPayableText }} ></span></td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>

                                    { /* write out any more info texts */}

                                    {
                                        novunaOptions.map((product, index) =>
                                            <div className="mt-4" key={"productMoreInfo_" + index}>
                                                <p className="cdibcText" dangerouslySetInnerHTML={{ __html: product.moreInfoText }}></p>
                                            </div>
                                        )
                                    }

                                    {
                                        novunaTerms
                                        &&
                                            <div className="mt-4">
                                                <div dangerouslySetInnerHTML={{ __html: novunaTerms }}></div>
                                            </div>
                                    }


                                </div>
                                <div className="modal-footer border-0">
                                    <button type="button" className="no-button white-button p-3 text-casing" onClick={() => { closeModalButton.current.click() }} >Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
            }

            {/* PayPal Credit modal */}
            {
                (paypalOptions && paypalOptions.length > 0)
                &&
                    <div className="finance-modal modal fade" id="payPalCreditModal" tabIndex="-1" aria-hidden="true" data-bs-backdrop="static">
                        <div className="modal-dialog modal-xl modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header border-0">
                                    <h2 className="modal-title mb-0">Spread the cost with PayPal Credit</h2>
                                    <button ref={closeModalButton} type="button" className="btn-close close-button float-end" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">

                                    <div className="table-responsive mb-3">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th className="text-casing text-muted">Payment Plan</th>
                                                    <th className="text-casing text-muted">Monthly Payment</th>
                                                    <th className="text-casing text-muted">Instalments</th>
                                                    <th className="text-casing text-muted">Total Amount Payable</th>
                                                    <th className="text-casing text-muted">Instalment Interest p.a.</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    paypalOptions.map((product, index) =>

                                                        <tr key={"product_" + index}>
                                                            <th>{product.paymentPlan}</th>
                                                            <td><span dangerouslySetInnerHTML={{ __html: product.monthlyPaymentText }} ></span></td>
                                                            <td>{product.term}</td>
                                                            <td><span dangerouslySetInnerHTML={{ __html: product.totalPaymentText }} ></span></td>
                                                            <td><span dangerouslySetInnerHTML={{ __html: product.instalmentRateText }} ></span></td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    <div>

                                        <h4>How PayPal Credit would work for future purchases</h4>

                                        <p>PayPal Credit acts like an online credit card, and gives you a credit limit that can be used for this and future purchases. PayPal Credit gives customers access to a range of instalment and purchase offers. Eligible purchases from {companyName} can use instalment offers, giving you access to a lower rate for the instalment period. Any outstanding balance after this period is subject to PayPal Credit's standard rate of interest, currently 23.9% (variable).</p>
                                        <p>If you already have PayPal Credit, there is no need to re-apply, just choose PayPal Credit at checkout.</p>

                                        <h4>Representative Example:</h4>

                                        <div className="row row-cols-1 row-cols-md-3 g-4 mb-3">
                                            <div className="col">
                                                <div className="card bg-light h-100 border-0">
                                                    <div className="card-body">
                                                        <h5 className="card-title text-center">Purchase rate p.a. (variable)</h5>
                                                        <h2 className="card-text text-center mb-0">23.9%</h2>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card bg-light h-100 border-0">
                                                    <div className="card-body">
                                                        <h5 className="card-title text-center">Representative APR (variable)</h5>
                                                        <h2 className="card-text text-center mb-0">23.9%</h2>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card bg-light h-100 border-0">
                                                    <div className="card-body">
                                                        <h5 className="card-title text-center">Assumed credit limit</h5>
                                                        <h2 className="card-text text-center mb-0">&pound;1,200</h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <p>Subject to credit approval. <a href="https://www.paypal.com/uk/webapps/mpp/paypal-virtual-credit/faq" target="_blank">Terms and conditions apply</a>. {companyName} acts as a broker and offers credit solely from PayPal UK Ltd, Whittaker House, Whittaker Avenue, Richmond-Upon-Thames, Surrey, United Kingdom, TW9 1EH.</p>

                                    </div>

                                </div>
                                <div className="modal-footer border-0">
                                    <button type="button" className="no-button white-button text-casing p-3" onClick={() => { closeModalButton.current.click() }} >Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
            }

            {/* Dopple modal */}
            {
                (dopplePay)
                &&
                    <div className="finance-modal modal fade" id="doppleModal" tabIndex="-1" aria-hidden="true" data-bs-theme="dark" data-bs-keyboard="false">
                        <div className="modal-dialog modal-lg modal-dialog-centered bg-transparent">
                            <div className="modal-content border-0">
                                <div id="doppleModalBody" className="modal-body p-1 position-relative bg-dark rounded">
                                    <button type="button" className="btn-close position-absolute top-0 end-0 mt-4 me-4 p-4 bg-transparent" data-bs-dismiss="modal" aria-label="Close"></button>
                                    {
                                        iframeSrc 
                                        && 
                                            <iframe ref={iframeRef} id="doppleCalculatorIframe" src={iframeSrc} className="w-100 border-0" title="Dopple Finance Calculator" style={{height: "85vh"}} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </>
	);
}